var option_default = {
  "option": "OdMD4",
  "user_choice": "hsWWw",
  "check": "XYD0D",
  "image": "lXncj",
  "input": "_2ZiFO",
  "title": "PseZx",
  "centered": "mzyiF",
  "with_result": "gI3q1",
  "list": "froxM",
  "with_image": "_1eAa7",
  "progress": "J0--a",
  "progress_value": "_9D7-P",
  "label": "Yberu",
  "cta": "_475L4",
  "adornment_icon": "_0yrT-",
  "remove": "BOamj",
  "removeButton": "wSKT2",
  "removeButtonIcon": "wubfF",
  "overlay": "RCkDe",
  "shown": "C8FRW",
  "dark": "yIHep",
  "spinner": "xQN-i",
  "spin": "QxH-w"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
